export default {
  "app.components.SideMenu.LeftMenu.clients": "clients- TH",
  "app.components.SideMenu.LeftMenu.tag": "tag- TH",
  "app.components.SideMenu.LeftMenu.SearchRec ": "Search Recommend-TH",
  "app.components.SideMenu.LeftMenu.fundList": "fund list - TH",

  "app.components.SideMenu.LeftMenu.FundRec": "Fund Recommend -TH",
    "app.components.SideMenu.LeftMenu.FundRec_FundMan": "By Fund Manager-TH",
    "app.components.SideMenu.LeftMenu.FundRec_Condi": "By Condition-TH",
    "app.components.SideMenu.LeftMenu.FundRec_Risk": "SIMPLE ADVISORY-TH",

  "app.components.SideMenu.LeftMenu.transaction": "transaction - TH",
    "app.components.SideMenu.LeftMenu.transactionDetails": "Transaction details- TH",
    "app.components.SideMenu.LeftMenu.requestATSDetails": "Transaction details- TH",

  "app.components.SideMenu.LeftMenu.ConFd": "content feed- TH",
    "app.components.SideMenu.LeftMenu.ConFd_NewsOld": "ข่าวสาร",
    "app.components.SideMenu.LeftMenu.ConFd_Invest": "มุมมองการลงทุน",
    "app.components.SideMenu.LeftMenu.ConFd_News": "ข่าวสารและรางวัล",
    "app.components.SideMenu.LeftMenu.ConFd_ConInvest": "สาระการลงทุน",
    "app.components.SideMenu.LeftMenu.ConFd_ManualInvest": "คู่มือนักลงทุน",
    "app.components.SideMenu.LeftMenu.ConFd_NotiInvest": "ประกาศกองทุนรวม",
    "app.components.SideMenu.LeftMenu.ConFd_PVDNewsReport": "รายงาน ข่าวสารกองทุนสำรองเลี้ยงชีพ",
    "app.components.SideMenu.LeftMenu.ConFd_PVDPlaning": "คลังความรู้ด้านการวางแผนการเงิน",
    "app.components.SideMenu.LeftMenu.ConFd_PVDFactSheet": "หนังสือชี้ชวนส่วนสรุปกองทุนสำรองเลี้ยงชีพ",
    
    "app.components.SideMenu.LeftMenu.ContFS": "content feed sort- TH",

  "app.components.SideMenu.LeftMenu.Notification": "การแจ้งเตือนในแอป",
    "app.components.SideMenu.LeftMenu.Notification_Detail": "สร้างใหม่",
  "app.components.SideMenu.LeftMenu.PushNoti": "การแจ้งเตือน",
    "app.components.SideMenu.LeftMenu.PushNoti_Compose": "เขียนการแจ้งเตือน",
  
  "app.components.SideMenu.LeftMenu.Nav": "NAV",

  "app.containers.NavList.tabNavHistory": "ประวัติ NAV",
  "app.containers.NavList.tabTopHolding": "Top Holding",
  "app.containers.NavList.tabSyncStatus": "สถานะการ Sync",
  "app.containers.NavList.tabLatestByFund": "ล่าสุดต่อกองทุน",
  "app.containers.NavList.colLatestPriceChg": "PRICE CHG ล่าสุด",
  "app.containers.NavList.colLatestPercentChg": "PERCENT CHG ล่าสุด",
  "app.containers.NavList.colLatestReturnType": "RETURN TYPE",
  "app.containers.NavList.colLatestSourceTypeNav": "SOURCE TYPE NAV",
  "app.containers.NavList.latestByFundCaption": "หนึ่งแถวต่อหนึ่งกองทุน: NAV ล่าสุดที่ระบบมี ทั้งหมด {funds} กองทุน",

  "app.containers.NavList.filterFund": "กองทุน",
  "app.containers.NavList.filterFundPlaceholder": "ทุกกองทุน",
  "app.containers.NavList.filterFundLoading": "กำลังโหลดรายชื่อกองทุน...",
  "app.containers.NavList.filterFundCode": "รหัสกองทุน",
  "app.containers.NavList.filterFundCodePlaceholder": "ค้นหาด้วยรหัสกองทุน",
  "app.containers.NavList.filterNavDate": "วันที่ NAV",
  "app.containers.NavList.filterValueDate": "Value date",
  "app.containers.NavList.filterSourceTypeNav": "Source type NAV",
  "app.containers.NavList.filterSyncBy": "Sync โดย",
  "app.containers.NavList.filterRowsPerPage": "จำนวนแถวต่อหน้า",
  "app.containers.NavList.filterAnyPlaceholder": "ทั้งหมด",
  "app.containers.NavList.buttonSearch": "ค้นหา",
  "app.containers.NavList.buttonClear": "ล้างตัวกรอง",
  "app.containers.NavList.buttonRetry": "ลองอีกครั้ง",

  "app.containers.NavList.loadingNavHistory": "กำลังโหลดประวัติ NAV...",
  "app.containers.NavList.loadingTopHolding": "กำลังโหลด Top Holding...",
  "app.containers.NavList.loadingSyncStatus": "กำลังโหลดสถานะการ Sync...",
  "app.containers.NavList.emptyHeader": "ไม่พบข้อมูล",
  "app.containers.NavList.emptyBody": "ไม่มีข้อมูลที่ตรงกับตัวกรองนี้ ลองขยายช่วงวันที่ หรือล้างตัวกรองกองทุน",
  "app.containers.NavList.errorHeader": "โหลดข้อมูลที่ sync ไว้ไม่สำเร็จ",
  "app.containers.NavList.errorBodyWithDetail": "เรียกข้อมูลไม่สำเร็จ ({detail}) ข้อมูลด้านล่างไม่ใช่ข้อมูลล่าสุด",
  "app.containers.NavList.errorBodyNetwork": "คำขอไปไม่ถึงเซิร์ฟเวอร์ ข้อมูลด้านล่างไม่ใช่ข้อมูลล่าสุด",
  "app.containers.NavList.errorStatus": "HTTP {status}",

  "app.containers.NavList.totalRows": "{total} แถว",
  "app.containers.NavList.pageOfTotal": "หน้า {page} จาก {pages}",
  "app.containers.NavList.goToPage": "ไปที่หน้า",
  "app.containers.NavList.goToPageButton": "ไป",

  "app.containers.NavList.colFundNo": "FUND NO.",
  "app.containers.NavList.colFundCode": "FUND CODE",
  "app.containers.NavList.colFundName": "ชื่อกองทุน",
  "app.containers.NavList.colSyncBy": "SYNC BY",
  "app.containers.NavList.colCreatedAt": "CREATED AT",
  "app.containers.NavList.colUpdatedAt": "UPDATED AT",
  "app.containers.NavList.colNavDate": "NAV DATE",
  "app.containers.NavList.colNavPerUnit": "NAV PER UNIT",
  "app.containers.NavList.colPriceChg": "PRICE CHG ล่าสุด",
  "app.containers.NavList.colPercentChg": "PERCENT CHG ล่าสุด",
  "app.containers.NavList.colReturnType": "RETURN TYPE",
  "app.containers.NavList.colNavEffdateRaw": "NAV EFFDATE RAW",
  "app.containers.NavList.colSourceTypeNav": "SOURCE TYPE NAV",
  "app.containers.NavList.colSeq": "SEQ",
  "app.containers.NavList.colListTh": "LIST (TH)",
  "app.containers.NavList.colListEng": "LIST (EN)",
  "app.containers.NavList.colAmountInv": "AMOUNT INV",
  "app.containers.NavList.colPercentInv": "PERCENT INV",
  "app.containers.NavList.colPercentInvRaw": "PERCENT INV RAW",
  "app.containers.NavList.colValueDate": "VALUE DATE",
  "app.containers.NavList.colJobName": "JOB NAME",
  "app.containers.NavList.colLastRunAt": "LAST RUN AT",
  "app.containers.NavList.colLastSuccessAt": "LAST SUCCESS AT",
  "app.containers.NavList.colLastStatus": "LAST STATUS",
  "app.containers.NavList.colRowsAffected": "ROWS AFFECTED",
  "app.containers.NavList.colDetail": "DETAIL",
  "app.containers.NavList.colRowCount": "จำนวนแถว",
  "app.containers.NavList.colEarliestNavDate": "NAV DATE แรกสุด",
  "app.containers.NavList.colLatestNavDate": "NAV DATE ล่าสุด",
  "app.containers.NavList.colLatestNavPerUnit": "NAV PER UNIT ล่าสุด",
  "app.containers.NavList.colLastSyncBy": "LAST SYNC BY",

  "app.containers.NavList.sectionSyncJobs": "งาน Sync",
  "app.containers.NavList.sectionCoverage": "ความครอบคลุมรายกองทุน",
  "app.containers.NavList.sectionMissingFunds": "กองทุนที่ไม่มีประวัติ NAV",
  "app.containers.NavList.missingFundsBody": "มี {count} กองทุน จากทั้งหมด {total} กองทุนในทะเบียนกองทุน ที่ไม่มีข้อมูลใน funds_nav_history เลย",
  "app.containers.NavList.missingFundsNone": "ทุกกองทุนในทะเบียนกองทุนมีประวัติ NAV ครบ ({total} กองทุน)",
  "app.containers.NavList.missingFundsUnknown": "อ่านทะเบียนกองทุนไม่สำเร็จ จึงยังบอกไม่ได้ว่ามีกองทุนใดขาดข้อมูล",
  "app.containers.NavList.coverageSummaryCount": "{funds} กองทุน รวม {rows} แถว NAV",
  "app.containers.NavList.badgeNoData": "ไม่มีข้อมูล",
  "app.containers.NavList.refresh": "โหลดใหม่",
  "app.containers.NavList.colActions": "ACTIONS",
  "app.containers.NavList.buttonSync": "Sync",
  "app.containers.NavList.buttonSyncing": "กำลัง Sync...",
  "app.containers.NavList.buttonCancel": "ยกเลิก",
  "app.containers.NavList.buttonClose": "ปิด",
  "app.containers.NavList.syncConfirmTitle": "Sync ประวัติ NAV ของ {fundCode}?",
  "app.containers.NavList.syncConfirmBody": "ระบบจะดึงประวัติ NAV ทั้งหมดของ {fundCode} ตั้งแต่จัดตั้งกองทุนจาก Portal อาจใช้เวลาสักครู่ และ Sync ได้ครั้งละหนึ่งรายการเท่านั้น",
  "app.containers.NavList.loadingSync": "กำลัง Sync ประวัติ NAV ของ {fundCode} อาจใช้เวลาสักครู่...",
  "app.containers.NavList.syncDoneTitle": "Sync เสร็จแล้ว",
  "app.containers.NavList.syncDoneBody": "Sync {fundCode} ตั้งแต่จัดตั้งกองทุนเสร็จแล้ว บันทึก {upserted} แถว ข้าม {skipped} แถว",
  "app.containers.NavList.syncFailedTitle": "Sync ไม่สำเร็จ",
  "app.containers.NavList.syncFailedFunds": "Sync {fundCode} ไม่สำเร็จ กองทุนที่ล้มเหลว: {fundNos}",
  "app.containers.NavList.syncUnknownOutcome": "ไม่ได้รับผลการ Sync {fundCode} ({reason}) ระบบอาจยัง Sync อยู่ ตรวจสอบที่แท็บสถานะการ Sync ก่อน Sync อีกครั้ง",
  "app.containers.NavList.syncNoResponse": "ไม่มีการตอบกลับ",
  "app.containers.NavList.buttonDelete": "ลบ",
  "app.containers.NavList.buttonDeleting": "กำลังลบ...",
  "app.containers.NavList.deleteConfirmTitle": "ลบประวัติ NAV ของ {fundCode}?",
  "app.containers.NavList.deleteConfirmBody": "ระบบจะลบประวัติ NAV ของ {fundCode} ในช่วงวันที่ด้านล่าง เว้นวันที่ว่างไว้เพื่อลบทุกวัน การ Sync จะดึงกลับมาได้เฉพาะแถวที่ Portal ยังมีอยู่ แถวที่เพิ่มด้วยมือจะหายไปถาวร",
  "app.containers.NavList.deleteHandInsertedWarning": "NAV ล่าสุดของ {fundCode} บันทึกโดย {syncBy} ไม่ได้มาจากการ Sync กับ Portal แถวลักษณะนี้จะไม่กลับมาเมื่อ Sync",
  "app.containers.NavList.deleteDateFrom": "ตั้งแต่วันที่",
  "app.containers.NavList.deleteDateTo": "ถึงวันที่",
  "app.containers.NavList.loadingDelete": "กำลังลบประวัติ NAV ของ {fundCode}...",
  "app.containers.NavList.deleteDoneTitle": "ลบเสร็จแล้ว",
  "app.containers.NavList.deleteDoneBody": "ลบ NAV ของ {fundCode} แล้ว {rows} แถว ({range})",
  "app.containers.NavList.deleteRangeAll": "ทุกวัน",
  "app.containers.NavList.deleteRangeFrom": "ตั้งแต่ {from}",
  "app.containers.NavList.deleteRangeUntil": "จนถึง {to}",
  "app.containers.NavList.deleteRangeBetween": "{from} ถึง {to}",
  "app.containers.NavList.deleteFailedTitle": "ลบไม่สำเร็จ",
  "app.containers.NavList.deleteIncomplete": "ลบประวัติ NAV ของ {fundCode} ไม่สำเร็จ",
  "app.containers.NavList.deleteUnknownOutcome": "ไม่ได้รับผลการลบ {fundCode} ({reason}) กดโหลดใหม่ที่แท็บนี้เพื่อดูว่าประวัติ NAV ถูกลบแล้วหรือไม่",

  "app.container.ClientDetail.Conservative": "อนุรักษ์นิยม (ระดับ 1)",
  "app.container.ClientDetail.ModerateConservative": "ยับยั้งปานกลาง (ระดับ 2)",
  "app.container.ClientDetail.Moderate": "ปานกลาง (ระดับ 3)",
  "app.container.ClientDetail.ModerateAggressive": "ปานกลางก้าวร้าว (ระดับ 4)",
  "app.container.ClientDetail.Aggressive5": "ก้าวร้าว (ระดับ 5)",
  "app.container.ClientDetail.Aggressive6": "ก้าวร้าว (ระดับ 6)"
};
